import Paper, { PaperProps } from '@mui/material/Paper';
import ByzMuiTypography from 'src/components/core-components/mui/inputs/ByzMuiTypography';

// ----------------------------------------------------------------------

interface Props extends PaperProps {
  query?: string;
}

export default function SearchNotFound({ query, sx, ...other }: Props) {
  return query ? (
    <Paper
      sx={{
        bgcolor: 'unset',
        textAlign: 'center',
        ...sx,
      }}
      {...other}
    >
      <ByzMuiTypography variant="h6" gutterBottom>
        Not Found
      </ByzMuiTypography>

      <ByzMuiTypography variant="body2">
        No results found for &nbsp;
        <strong>&quot;{query}&quot;</strong>.
        <br /> Try checking for typos or using complete words.
      </ByzMuiTypography>
    </Paper>
  ) : (
    <ByzMuiTypography variant="body2" sx={sx}>
      Please enter keywords
    </ByzMuiTypography>
  );
}
